class JdnextCountdown extends HTMLElement {
  connectedCallback() {
    this._update();
    this._timer = setInterval(() => this._update(), 60000);
  }

  disconnectedCallback() {
    clearInterval(this._timer);
  }

  _update() {
    const earlyDeadline = this._deadlineUTC(this.dataset.earlyDeadline);
    const standardDeadline = this._deadlineUTC(this.dataset.standardDeadline);

    if (!earlyDeadline || !standardDeadline) {
      return;
    }

    const now = Date.now();
    let deadlineDateStr;

    if (now < earlyDeadline.getTime()) {
      deadlineDateStr = this.dataset.earlyDeadline;
    } else if (now < standardDeadline.getTime()) {
      deadlineDateStr = this.dataset.standardDeadline;
    } else {
      this.hidden = true;

      return;
    }

    const days = Math.max(1, this._calendarDaysUntil(deadlineDateStr));
    const textEl = this.querySelector('.jdnext-countdown__text');

    if (textEl) {
      textEl.textContent = days === 1 ? '1 day left at this rate' : `${days} days left at this rate`;
    }
  }

  _calendarDaysUntil(dateStr) {
    const todayET = new Date().toLocaleDateString('en-CA', { timeZone: 'America/New_York' });
    const [ty, tm, td] = todayET.split('-').map(Number);
    const [dy, dm, dd] = dateStr.split('-').map(Number);

    return Math.round((Date.UTC(dy, dm - 1, dd) - Date.UTC(ty, tm - 1, td)) / 86400000);
  }

  _deadlineUTC(dateStr) {
    if (!dateStr) {
      return null;
    }

    const [year, month, day] = dateStr.split('-').map(Number);

    if (!year || !month || !day) {
      return null;
    }

    const noonUTC = new Date(Date.UTC(year, month - 1, day, 12, 0, 0));
    let utcOffset = 5;

    try {
      const etHour = parseInt(
        noonUTC.toLocaleString('en-US', { timeZone: 'America/New_York', hour: 'numeric', hour12: false })
      );

      if (!isNaN(etHour)) {
        utcOffset = 12 - etHour;
      }
    } catch {
      console.warn('[jdnext-countdown] Could not resolve ET offset, defaulting to UTC-5');
    }

    return new Date(Date.UTC(year, month - 1, day, 23 + utcOffset, 59, 59));
  }
}

if (!customElements.get('jdnext-countdown')) {
  customElements.define('jdnext-countdown', JdnextCountdown);
}
